import React from 'react';
import '../master-header/master-header.styles.less';
import { Layout } from 'antd';
import { Text } from 'components/text/Text';
import { LOGO } from '../../../../assets/icons/icons';
import { translate, translationKeys } from '../../../../logic/translations/translations.service';
const { Header } = Layout;

export const NonClickableHeader: React.FC<{ headerText?: string }> = ({
  headerText = translate(translationKeys.publishOffer.pageHeaderText),
}) => {
  return (
    <Header className="master-header noselect">
      <div className="header-container">
        <div className="left-menu-content">
          <img className="logo" src={LOGO} alt="logo" loading="lazy" />
          <div style={{ marginLeft: '28px' }}>
            <Text size={22} color="grey">
              {headerText}
            </Text>
          </div>
        </div>
      </div>
    </Header>
  );
};
